import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

export const OptionItemSquareListStyles = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 0 16px;
`;

export const OptionItemSquareStyles = styled.div<{
  isSelected: boolean;
  bgSrc: string;
}>`
  body.dark & {
    --bg-color: #30283e;
    --bg-color-selected: #2d1a55;
  }

  --bg-color: #ffffff80;
  --bg-color-selected: #ece4fd;
  box-sizing: border-box;
  aspect-ratio: 0.83;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  cursor: pointer;
  padding: 12px;
  border-radius: 16px;
  position: relative;
  font-size: 0;
  line-height: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    font-size: 0;
    line-height: 0;
  }

  & > .shadow-mask {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% + 1px);
    height: calc(100% + 1px);
    z-index: 2;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, #000 100%);
    box-sizing: border-box;
    border-radius: 15px;
    font-size: 0;
    line-height: 0;

    ${({ isSelected }) =>
      isSelected &&
      `
        outline: 4px solid #803eff;
        outline-offset: -4px;
      `}
  }
`;

export const OptionItemSquareTitleStyles = styled(UiTypography)`
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  margin: 0;
`;
